import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import isString from 'lodash-es/isString';
import { ElementType } from 'react';

import useLocationTypes from '../../hooks/useLocationTypes';

import LocationTypeHorizontalCard from '../cards/LocationTypeHorizontalCard';
import PresentationList, { PresentationListProps } from './PresentationList';

import styles from '../../styles/lists/location-types-list.module.css';

const CardComponents = {
    Horizontal: LocationTypeHorizontalCard,
};

const hooks = {
    default: useLocationTypes,
};

interface LocationTypesListProps extends Omit<
    PresentationListProps<LocationType>,
    'cardComponent' | 'hook'
> {
    hook?: string | null;
    cardComponent?: ElementType | null;
    cardType?: string | null;
}

function LocationTypesList({
    hook = 'default',
    cardType = null,
    cardComponent = null,
    itemsClassName = null,
    ...props
}: LocationTypesListProps) {
    return (
        <PresentationList<LocationType>
            hook={isString(hook) ? hooks[hook] || hooks.default : hook}
            paginated={false}
            {...props}
            cardComponent={
                cardComponent ||
                getComponentFromName(CardComponents, cardType, LocationTypeHorizontalCard)
            }
            itemsClassName={classNames([styles.items, itemsClassName])}
        />
    );
}

export default LocationTypesList;
